import React from "react";

export default function Marquee() {
  const items = [
    "Performance Chew",
    "Focus",
    "Calm",
    "Control",
    "Resistance",
    "Sugar Free",
    "Eucalyptus Mint",
    "Lock In",
  ];
  const all = [...items, ...items];

  return (
    <div data-testid="marquee" className="marquee bg-black/40 py-8 relative z-10">
      <div className="marquee__track">
        {all.map((t, i) => (
          <span
            key={i}
            className="font-display text-4xl md:text-6xl lg:text-7xl uppercase flex items-center gap-16"
            style={{ letterSpacing: "0.02em" }}
          >
            <span className={i % 2 ? "outline-text" : "text-white"}>{t}</span>
            <span
              className="inline-block w-3 h-3 rounded-full"
              style={{ background: "var(--blue-bright)", boxShadow: "0 0 18px var(--blue-bright)" }}
            />
          </span>
        ))}
      </div>
    </div>
  );
}
